import React from "react";

import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

// Scss
import styles from "./StatusConfirmation.module.scss";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StatusConfirmation = ({
  showModal,
  title,
  message,
  buttonLabel,
  handleCancelClick,
  handleSubmitClick,
  buttonLabel1,
  handleSubmitClick1
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={showModal}
        TransitionComponent={Transition}
        onClose={handleCancelClick}
        classes={{
          paper: styles.modalDialog,
        }}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogContent className={styles.modalContent}>
          <div className={`text-center ${styles.modalBody}`}>
            <h5 className={`my-3 text-center ${styles.modalTitle}`}>{title}</h5>
            <p className={`popup-info-text ${styles.modalMessage}`}>
              {" "}
              {message}{" "}
            </p>
            <a
              href="/"
              data-dismiss="modal"
              onClick={handleSubmitClick}
              className="btn gray-btn d-inline-block mb-3 mr-2"
            >
              {" "}
              {buttonLabel}{" "}
            </a>
            <a
              href="/"
              data-dismiss="modal"
              onClick={handleSubmitClick1}
              className="btn gray-btn d-inline-block mb-3 mr-2"
            >
              {" "}
              {buttonLabel1}{" "}
            </a>
            <a
              href="/"
              data-dismiss="modal"
              onClick={handleCancelClick}
              className="btn gray-btn d-inline-block mb-3"
            >
              {" "}
              Cancel{" "}
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default StatusConfirmation;
